import React from 'react';
import { motion } from 'framer-motion';
interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  as?: 'div' | 'section' | 'li';
}
export function Reveal({
  children,
  delay = 0,
  className,
  as = 'div'
}: RevealProps) {
  const MotionTag = motion[as];
  return <MotionTag className={className} initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.55,
    ease: [0.22, 1, 0.36, 1],
    delay
  }} data-id="element-132" data-mp="3gh8o2om48g7n">
      {children}
    </MotionTag>;
}